"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cloneCarouselItems = exports.cloneCarouselItems = function cloneCarouselItems() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemsInSlide = arguments[1];
  var props = arguments[2];

  var items = itemsInSlide || 1;

  var _ref = props || {},
      stagePadding = _ref.stagePadding,
      infinite = _ref.infinite;

  var _getStagePadding = getStagePadding({ stagePadding: stagePadding }),
      paddingLeft = _getStagePadding.paddingLeft,
      paddingRight = _getStagePadding.paddingRight;

  if (items > children.length) {
    items = children.length;
  }

  if (infinite) {
    if (paddingLeft || paddingRight) {
      if (itemsInSlide < children.length) {
        items = itemsInSlide + 1;
      } else {
        var lastElement = children.slice(-1);
        var firstElement = children.slice(0, 1);
        var _clonesBefore = lastElement.concat(children);
        var _clonesAfter = children.concat(firstElement);

        return [].concat(_clonesBefore, children, _clonesAfter);
      }
    }
  }

  var clonesAfter = children.slice(0, items);
  var clonesBefore = children.slice(children.length - items);

  return [].concat(clonesBefore, children, clonesAfter);
};

var getElementWidth = exports.getElementWidth = function getElementWidth(element) {
  if (element && element.getBoundingClientRect) {
    return element.getBoundingClientRect().width;
  }
};

var getSlides = exports.getSlides = function getSlides(props) {
  var _ref2 = props || {},
      children = _ref2.children,
      _ref2$items = _ref2.items,
      items = _ref2$items === undefined ? [] : _ref2$items;

  return children && children.length ? children : items;
};

var itemInfo = exports.itemInfo = function itemInfo(props) {
  var _ref3 = props || {},
      items = _ref3.items,
      currentIndex = _ref3.currentIndex,
      infinite = _ref3.infinite,
      _ref3$slides = _ref3.slides,
      slides = _ref3$slides === undefined ? [] : _ref3$slides;

  var inactivePrev = infinite === false && currentIndex === 0;
  var inactiveNext = infinite === false && slides.length - items === currentIndex;

  return { inactivePrev: inactivePrev, inactiveNext: inactiveNext };
};

var getStagePadding = exports.getStagePadding = function getStagePadding(props) {
  var _ref4 = props || {},
      _ref4$stagePadding = _ref4.stagePadding,
      stagePadding = _ref4$stagePadding === undefined ? {} : _ref4$stagePadding;

  var paddingLeft = Math.abs(stagePadding.paddingLeft) || 0;
  var paddingRight = Math.abs(stagePadding.paddingRight) || 0;

  return { paddingLeft: paddingLeft, paddingRight: paddingRight };
};

var getItemWidth = exports.getItemWidth = function getItemWidth() {
  var galleryWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var totalItems = arguments[1];

  var width = Number(galleryWidth);
  var items = Number(totalItems);
  return width && items > 0 ? width / items : 0;
};

var getSlideInfo = exports.getSlideInfo = function getSlideInfo() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var slidesLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var slideIndex = index + 1;

  if (slideIndex < 1) {
    slideIndex = slidesLength;
  } else if (slideIndex > slidesLength) {
    slideIndex = 1;
  }

  return { slideIndex: slideIndex, slidesLength: slidesLength };
};

var isElement = exports.isElement = function isElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
};

var getNextItemIndexBeforeTouchEnd = exports.getNextItemIndexBeforeTouchEnd = function getNextItemIndexBeforeTouchEnd(currentTranslateXPosition) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var infinite = state.infinite,
      _state$items = state.items,
      items = _state$items === undefined ? 1 : _state$items,
      _state$itemWidth = state.itemWidth,
      itemWidth = _state$itemWidth === undefined ? 0 : _state$itemWidth,
      _state$slides = state.slides,
      slides = _state$slides === undefined ? [] : _state$slides,
      _state$stagePadding = state.stagePadding,
      stagePadding = _state$stagePadding === undefined ? {} : _state$stagePadding;
  var paddingLeft = stagePadding.paddingLeft,
      paddingRight = stagePadding.paddingRight;


  if (itemWidth <= 0 || items > slides.length) {
    return 0;
  }

  var currInd = Math.abs(currentTranslateXPosition / itemWidth) - items;

  if (infinite) {
    if (paddingLeft || paddingRight) {
      currInd -= 1;
    }
  }

  if (currInd === slides.length) {
    return 0;
  }
  if (currInd < 0) {
    return slides.length + currInd;
  }

  return currInd;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/utils/elements.js
// module id = 278
// module chunks = 0